// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"W7-z"};